<div class="analyse">
  <p [innerHTML]="textKeyPrefix + '.subheadline' | translate"></p>
  <div class="consumption consumption-{{ textPlaceholder?.stage }}">
    <i class="icon-shower-top"></i>
    <div>
        <p [innerHTML]="(textKeyPrefix + '.total.consumption.' + (textPlaceholder?.one_person === true ? 'one.person.' : '') + textPlaceholder?.stage) | translate: textPlaceholder | safeHtml"></p>
    </div>
  </div>
  <ol class="stages">
    @for (currentStage of textPlaceholder?.all_stages; track currentStage; let isLast = $last) {
      <li class="stage{{currentStage.person.name.toUpperCase()}}" [class.active]="textPlaceholder?.stage === currentStage.person.name.toUpperCase()">
        <strong>{{ currentStage.person.name.toUpperCase() }}</strong>
        @if (textPlaceholder?.one_person === true) {
          <p>{{textKeyPrefix + '.consumption.stage.' + (isLast? 'min' : 'max')| translate: {min: currentStage?.household?.min?.toLocaleString(), max: currentStage?.household?.max?.toLocaleString()} }}</p>
        }
        @else {
          <p><span>{{textKeyPrefix + '.haushalt' | translate}}</span> {{textKeyPrefix + '.consumption.stage.' + (isLast? 'min' : 'max')| translate: {min: currentStage?.household?.min?.toLocaleString(), max: currentStage?.household?.max?.toLocaleString()} }}</p>
          <p><span>{{textKeyPrefix + '.person' | translate}}</span> {{textKeyPrefix + '.consumption.stage.' + (isLast? 'min' : 'max')| translate: {min: currentStage?.person?.min?.toLocaleString(), max: currentStage?.person?.max?.toLocaleString()} }}</p>
        }
        <span class="label" [innerHTML]="textKeyPrefix + '.consumption.stage.label' | translate"></span>
      </li>
    }
  </ol>
  <div class="direction stage{{ textPlaceholder?.stage }}">
    <span></span>
    <span class="label" [innerHTML]="textKeyPrefix + '.better' | translate"></span>
  </div>

  <div class="infotext-wrapper">
    <button type="button" [attr.aria-expanded]="showHint" aria-controls="hint" (click)="showHint = !showHint" class="infocallout-button"><i class="icon-info"></i> <span [innerHTML]="textKeyPrefix + '.household.hint.label' | translate"></span></button>
     @if(showHint) {
       <div id="hint" class="callout infocallout lighter-gray">
         <button class="close" [attr.aria-label]="'arialabel.close' | translate" (click)="showHint = false"><i class="icon-x"></i></button>
         <p [innerHTML]="textKeyPrefix + '.household.hint' | translate"></p>
       </div>
     }
  </div>
</div>
